import React, { createContext, useContext, useEffect, useState } from "react";

const RevisionFormContext = createContext(null);

const RevisionFormProvider = ({
  children,
  flow,
  revisionId,
  revisionDate,
  currentAuthor,
  currentMainTab,
  isDeveloper,
  showAdditionalCommentButton,
  content,
  selectedProposalIndex,
  allowComments,
  onClickEditProposal,
  onCreatedDevRevision,
}) => {

  const [revisionContent, setRevisionContent] = useState(content);
  const [activeSectionIndex, setActiveSectionIndex] = useState(0);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [activeMockupIndex, setActiveMockupIndex] = useState(0);

  const proposal = revisionContent.proposals[selectedProposalIndex];

  const resetMediaIndexes = () => {
    setActiveTabIndex(0);
    setActiveMockupIndex(0);
  }

  const onClickPrevSection = () => {
    setActiveSectionIndex(activeSectionIndex - 1);
    resetMediaIndexes();
  }

  const onClickNextSection = () => {
    setActiveSectionIndex(activeSectionIndex + 1);
    resetMediaIndexes();
  }

  const onClickSelectSection = (sectionIndex) => {
    setActiveSectionIndex(sectionIndex);
    resetMediaIndexes();
  }

  const updateProposal = (getNextProposal) => {
    setRevisionContent((currentContent) => {
      const proposals = [...currentContent.proposals];
      proposals[selectedProposalIndex] = getNextProposal(proposals[selectedProposalIndex]);

      return {
        ...currentContent,
        proposals,
      };
    });
  }

  const updateSection = (sectionIndex, getNextSection) => {
    updateProposal((currentProposal) => {
      const sections = [...(currentProposal.content || [])];
      sections[sectionIndex] = getNextSection(sections[sectionIndex]);
      return {
        ...currentProposal,
        content: sections,
      };
    });
  }

  const setGlobalAdditionalComments = (additionalComments) => {
    updateProposal((currentProposal) => ({
      ...currentProposal,
      additional_comments: additionalComments || "",
    }));
  }

  useEffect(() => {
    setRevisionContent(content);
  }, [content]);

  useEffect(() => {
    setActiveSectionIndex(0);
    setActiveTabIndex(0);
    setActiveMockupIndex(0);
  }, [revisionId, selectedProposalIndex]);

  return (
    <RevisionFormContext.Provider
      value={{
        flow,
        revisionId,
        revisionDate,
        currentAuthor,
        currentMainTab,
        isDeveloper,
        showAdditionalCommentButton,
        selectedProposalIndex,
        allowComments,
        onClickEditProposal,
        onCreatedDevRevision,
        content: revisionContent,
        setContent: setRevisionContent,
        proposal,
        activeSectionIndex,
        setActiveSectionIndex,
        activeTabIndex,
        setActiveTabIndex,
        activeMockupIndex,
        setActiveMockupIndex,
        onClickPrevSection,
        onClickNextSection,
        onClickSelectSection,
        updateProposal,
        updateSection,
        setGlobalAdditionalComments,
      }}
    >
      {children}
    </RevisionFormContext.Provider>
  );
}

const useRevisionFormContext = () => {
  const context = useContext(RevisionFormContext);
  if (context == null) {
    throw new Error("useRevisionFormContext must be used inside RevisionFormProvider");
  }
  return context;
}

export {
  RevisionFormProvider,
  useRevisionFormContext,
}
